import React from "react";
import "./index.css";

const GetStartedBtn = ({ btnText }) => {
  return <button className="getstarted">{btnText}</button>;
};

export default GetStartedBtn;
